export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export function isTruthy<T>(value?: T | undefined | null | false): value is T {
  return !!value;
}
